module.exports = __webpack_public_path__ + "img/Rettungs_und_Sicherungsboot.aa5d25e8.svg";